import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './FrontEnd/App/cartSlice'; // Adjust the path based on your folder structure

const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

export default store;
